import { useQuery } from 'react-query';

import { useBrand } from '@src/contexts/brand-context/use-brand';
import { useTrip } from '@src/contexts/trip-context/use-trip';

const useWhatsappQuery = () => {
  const { brand } = useBrand();

  const tripContext = useTrip();
  const whatsAppNumber = tripContext?.trip?.property?.whatsappNumber ?? brand.whatsappNumberV2?.number;

  return useQuery(
    ['whatsapp', whatsAppNumber],
    async () => {
      let trimmedNumber;
      try {
        const libphonenumber = await import('google-libphonenumber');
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        const numberInE164Format = phoneUtil.format(
          phoneUtil.parse(whatsAppNumber),
          libphonenumber.PhoneNumberFormat.E164,
        );
        trimmedNumber = numberInE164Format.replace(/^\+/, '');
      } catch (e) {
        trimmedNumber = whatsAppNumber.replace(/(^[+0]|\s|-)/gi, '');
      }

      return {
        number: whatsAppNumber,
        link: `https://wa.me/${trimmedNumber}`,
      };
    },
    {
      enabled: !!whatsAppNumber,
    },
  );
};

export default useWhatsappQuery;
